import React from "react";
import lockImg from "../../../../static/images/lock.svg";
import Loader from "../../../../static/images/spinner.svg";
import styles from "./signAndLock.module.scss";

export const LockButton = ({ disabled, loading, onLock }) => (
  <button className={styles.lock} data-testid="lock" onClick={onLock} disabled={disabled}>
    <img src={lockImg} alt="lock" />
    Lock{" "}
    {loading && (
      <span className={`${styles.sign_lock_loader} pl-1`}>
        <img src={Loader} alt="loading" />
      </span>
    )}
  </button>
);
